import './css/reset.css';
import Layout from "./layouts/Layout";

function App() {
    return (
        <div className="App">
            <Layout />
        </div>
    );
}

export default App;
